import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { Auth0Provider } from "@auth0/auth0-react";
// import reportWebVitals from './reportWebVitals';
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;

  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('ResizeObserver loop completed')
    ) {
      return;
    }
    originalError(...args);
  };
}


const root = ReactDOM.createRoot(document.getElementById('root')); 


root.render(
  <React.StrictMode>
    {/* <App /> */}
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);
// root.render(<App />)

// reportWebVitals();
